import { createAction, props } from '@ngrx/store';
import { ExternalDocSearchInfo, ExternalDocPatientInfo, ExternalDocument } from '../../models/estensa-models.model';

export enum ExternalDocsActions {
    OPEN_EXTERNAL_DOCS_DIALOG = '[Se] seOpenExternalDocsOnDialog',
    SET_SELECT_EXTERNAL_DOC = '[Se] seSetSelectExternalDoc',
    UPDATE_SELECTED_EXTERNAL_DOC = '[Se] seUpdateSelectExternalDoc',
    ADD_NEW_EXTERNAL_DOC = '[Se] seAddNewExternalDoc'
}

export const seOpenExternalDocsOnDialog = createAction(ExternalDocsActions.OPEN_EXTERNAL_DOCS_DIALOG,
    props<{ info: ExternalDocSearchInfo; patientInfo: ExternalDocPatientInfo, examinationsInfo: string[] }>());

export const seSetSelectExternalDoc = createAction(ExternalDocsActions.SET_SELECT_EXTERNAL_DOC,
    props<{ doc: ExternalDocument }>());

export const seUpdateSelectExternalDoc = createAction(ExternalDocsActions.UPDATE_SELECTED_EXTERNAL_DOC,
    props<{ doc: ExternalDocument }>());

export const seAddNewExternalDoc = createAction(ExternalDocsActions.ADD_NEW_EXTERNAL_DOC,
    props<{ doc: ExternalDocument }>());



